export enum LegalTermType {
  Custom = 'custom',
  DeliveryPolicy = 'delivery_policy',
  PrivacyPolicy = 'privacy_policy',
  ReturnsPolicy = 'returns_policy',
  TermsOfUse = 'terms_of_use'
}

export type LegalTermContentType = 'text' | 'external_link'

export interface LegalTerm {
  id?: number
  type: LegalTermType
  title: string
  text: string
  version?: string
  externalLink?: string
  appId?: number
  legalTermId?: number
  /** UI-only: preferred content mode while editing; not sent to the API. */
  activeContentType?: LegalTermContentType
}
